import type { Product, Venue, VenueReservation } from "@/graphql/operations";

export type FetchedMonthsRange = { from: Date | null; until: Date | null };

export type FetchReservationsOptions = {
  month?: Date;
  past?: number;
  future?: number;
};

export type MonthKey = string;

export type ReservationSearch = {
  venueId?: Venue["id"];
  productId?: Product["id"];
};

export type ReservationBounds = {
  earliestDate: Date | null;
  latestDate: Date | null;
  resolved: boolean;
};

export type ReservationsBucket = {
  blocks: ReservationsBlock[];
  activeBlockId: string | null;
  bounds: ReservationBounds;
};

export type ReservationsBlock = {
  id: string;
  from: Date;
  until: Date;
  reservations: VenueReservation[];
  totalReservations: number;
  reservationsStart: number;
  reservationsEnd: number;
  reachedPastEnd: boolean;
  reachedUpcomingEnd: boolean;
};

export type AppliedBucketState = {
  reservations: VenueReservation[];
  totalReservations: number;
  reservationsStart: number;
  reservationsEnd: number;
  reachedPastEnd: boolean;
  reachedUpcomingEnd: boolean;
  fetchedMonthsRange: FetchedMonthsRange;
  reservationBounds: ReservationBounds;
};

export const DEFAULT_PAST_MONTHS = 2;
export const DEFAULT_FUTURE_MONTHS = 2;
